import { 
    SET_GENERAL
} from '../actions';


// Inital zoom and center
const initialState = {
    modal_new_anomaly: false,
    modal_open: false,
    modal_update: false,
    updated: false,
    hidden_update_div: false,
    cancelAndClose: false,
    compare_list: [],
    view_anomaly: false,
    modify_button: false,
    modify_anomaly: false,
    hidden_button: false,
    isRestored: false
};

export default function(state = initialState, action:any){
    switch(action.type){
        case SET_GENERAL:
            return{
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}